import script from "./CartPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartPage.vue?vue&type=script&setup=true&lang=ts"

import "./CartPage.vue?vue&type=style&index=0&id=763212e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763212e6"]])

export default __exports__